import classNames from 'classnames'
import dayjs from 'dayjs'
import { TooltipWithPortal } from '@winnin/winnin_ui.components.tooltip-with-portal'

import GenerateWinninAIReportButton from 'components/GenerateWinninAIReportButton'
import TerritoryAddToCheckbox from 'components/TerritoryAddToCheckbox'

import { Favorite } from '../favorite'

export function FavoriteTableCell({ row }) {
  const [entityType] = row?.territoryId?.split('.') ?? []

  return (
    <div className={classNames(['favoriteContainer', { isActive: row?.isFollowed }])}>
      <Favorite
        initialSaveState={row?.isFollowed}
        territoryId={row?.territoryId}
        territoryName={row?.name}
        territoryType={entityType}
        size="sm"
      />
    </div>
  )
}

export function FormatTitleTableCell({ row, index }) {
  const splitId = row?.territoryId?.split('.') ?? []

  const addToItem = {
    id: splitId[1],
    name: row?.name,
    type: 'savedPostSearches',
  }

  return (
    <div className="TableTitleWithCheckbox">
      <div className="checkboxContainer">
        <div className="index">{index + 1}</div>
        <TerritoryAddToCheckbox entityObject={addToItem} entityType="saved_search" id={row?.id} />
      </div>
      <div className="FormatTitleTableCell">
        <p>{row?.topic?.name}</p>
        <span>
          <TooltipWithPortal tooltipMessage={row?.topic?.query?.substring(0, 200)}>
            {row?.topic?.query}
          </TooltipWithPortal>
        </span>
      </div>
    </div>
  )
}

export function FormatCreateByTableCell({ row }) {
  return (
    <div className="FormatCreateByTableCell">
      <p>{row?.createdBy?.firstName}</p>
      <span>{dayjs(row?.createdBy?.createdAt).from(dayjs())}</span>
    </div>
  )
}

export function FormatUploadDateTableCell({ row }) {
  return <div className="FormatUploadDateTableCell">{row?.uploadDate}</div>
}

export function FormatZaiTableCell({ row }) {
  return (
    <GenerateWinninAIReportButton
      id={row?.id}
      entity="saved_search"
      analyticsTrackerPageTitle={row?.topic?.name}
      zaiBtnConfig={{
        appearance: 'link',
        className: 'GenerateWinninAIReportButton-text',
        iconClassName: 'GenerateWinninAIReportButton-icon2',
      }}
    />
  )
}
